import { useCallback, useContext } from 'react'
import { InboxSiblingsContext } from '#src/contexts/InboxSiblingsContext.ts'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'

const EMPTY: NotificationItem[] = []

/*
 * Returns a function that, given a notification item, returns all sibling
 * notifications for the same underlying resource (including the item itself).
 *
 * Falls back to returning an empty array when called outside an
 * InboxSiblingsContext provider (e.g. in InboxDonePage where dedup siblings
 * aren't relevant).
 */
export function useInboxSiblings(): (
  item: NotificationItem
) => NotificationItem[] {
  const getSiblings = useContext(InboxSiblingsContext)
  return useCallback(
    (item: NotificationItem) => {
      if (!getSiblings) {
        return EMPTY
      }
      return getSiblings(item)
    },
    [getSiblings]
  )
}
